import {API_ROOT_URL} from 'envs/_current/config'
import {schema} from 'normalizr'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'

//  ===================================== course =====================================
export const musicSchema = new schema.Entity(
  'musics',
  {},
  {
    idAttribute: 'idname',
  }
)

export const music_getRecentlyItems_Api = {
  name: 'music_getRecentlyItems_Api',
  backend: `Route::get('musics/get-recently-items', 'MusicController@getRecentlyItems');`,
  root: API_ROOT_URL,
  path: '/musics/get-recently-items',
  method: 'GET',
  paramsFields: ['keyword'],
  schema: musicSchema,
  transform: createListTransform(musicSchema),
}

export const music_getMusics_Api = {
  name: 'music_getMusics_Api',
  backend: `Route::get('musics/get-musics', 'MusicController@getMusics');`,
  root: API_ROOT_URL,
  path: '/musics/get-musics',
  method: 'GET',
  paramsFields: ['keyword', 'music_type_ids', 'music_author_id', 'not_in_ids', 'imprimatur', 'language', 'status'],
  schema: musicSchema,
  transform: createListTransform(musicSchema),
}

export const music_createMusic_Api = {
  name: 'music_createMusic_Api',
  backend: `Route::post('musics/music/create', 'MusicController@createMusic');`,
  root: API_ROOT_URL,
  path: '/musics/music/create',
  method: 'POST',
  schema: musicSchema,
  transform: createTransform(musicSchema, 'data'),
}

export const music_deleteMusic_Api = {
  name: 'music_deleteMusic_Api',
  backend: `Route::post('musics/music/{id}/delete', 'MusicController@deleteMusic');`,
  root: API_ROOT_URL,
  path: '/musics/music/:id/delete',
  method: 'POST',
  schema: musicSchema,
  transform: createTransform(musicSchema, 'data'),
}

export const music_editMusic_Api = {
  name: 'music_editMusic_Api',
  backend: `Route::post('musics/music/{id}/update', 'MusicController@updateMusic');`,
  root: API_ROOT_URL,
  path: '/musics/music/:id/edit',
  method: 'POST',
  schema: musicSchema,
  transform: createTransform(musicSchema, 'data'),
}


export const music_acceptMusic_Api = {
  name: 'music_editMusic_Api',
  backend: `Route::post('musics/music/{id}/accept', 'MusicController@acceptMusic');`,
  root: API_ROOT_URL,
  path: '/musics/music/:id/accept',
  method: 'POST',
  schema: musicSchema,
  transform: createTransform(musicSchema, 'data'),
}

export const music_getMusicById_Api = {
  name: 'music_getMusicById_Api',
  backend: `Route::get('musics/music/{id}/get', 'MusicController@getById');`,
  root: API_ROOT_URL,
  path: '/musics/music/:id/get',
  method: 'GET',
  schema: musicSchema,
  transform: createTransform(musicSchema, 'data'),
}

export const musicAuthorSchema = new schema.Entity(
  'music_authors',
  {},
  {
    idAttribute: 'id',
  }
)

export const music_lookupAuthorBySysAdmin_Api = {
  name: 'music_lookupAuthorBySysAdmin_Api',
  backend: `Route::get('musics/lookup/author', 'MusicController@lookupAuthorBySysAdmin');`,
  root: API_ROOT_URL,
  path: '/musics/lookup/author',
  method: 'GET',
  paramsFields: ['keyword'],
  schema: musicAuthorSchema,
  transform: createListTransform(musicAuthorSchema),
}
export const music_getMusicAuthors_Api = {
  name: 'music_getMusicAuthors_Api',
  backend: `Route::get('musics/author/gets', 'MusicController@getMusicAuthors');`,
  root: API_ROOT_URL,
  path: '/musics/author/gets',
  method: 'GET',
  paramsFields: ['keyword'],
  schema: musicAuthorSchema,
  transform: createListTransform(musicAuthorSchema),
}

export const music_getHighlightedMusicAuthors_Api = {
  name: 'music_getHighlightedMusicAuthors_Api',
  backend: `Route::get('musics/author/fetch-highlighted-items', 'MusicController@getHighlightedMusicAuthors');`,
  root: API_ROOT_URL,
  path: '/musics/author/fetch-highlighted-items',
  method: 'GET',
  paramsFields: ['keyword'],
  schema: musicAuthorSchema,
  transform: createListTransform(musicAuthorSchema),
}

export const music_createMusicAuthor_Api = {
  name: 'music_createMusicAuthor_Api',
  backend: `Route::post('musics/author/create', 'MusicController@createMusicAuthorAuthor');`,
  root: API_ROOT_URL,
  path: '/musics/author/create',
  method: 'POST',
  schema: musicAuthorSchema,
  transform: createTransform(musicAuthorSchema, 'data'),
}

export const music_deleteMusicAuthor_Api = {
  name: 'music_deleteMusicAuthor_Api',
  backend: `Route::post('musics/author/{id}/delete', 'MusicController@deleteMusicAuthor');`,
  root: API_ROOT_URL,
  path: '/musics/author/:id/delete',
  method: 'POST',
  schema: musicAuthorSchema,
  transform: createTransform(musicAuthorSchema, 'data'),
}

export const music_editMusicAuthor_Api = {
  name: 'music_editMusicAuthor_Api',
  backend: `Route::post('musics/author/{id}/update', 'MusicController@updateMusicAuthor');`,
  root: API_ROOT_URL,
  path: '/musics/author/:id/edit',
  method: 'POST',
  schema: musicAuthorSchema,
  transform: createTransform(musicAuthorSchema, 'data'),
}

export const music_getMusicAuthorById_Api = {
  name: 'music_getMusicAuthorById_Api',
  backend: `Route::get('musics/author/{id}/get', 'MusicController@getMusicAuthorById');`,
  root: API_ROOT_URL,
  path: '/musics/author/:id/get',
  method: 'GET',
  schema: musicAuthorSchema,
  transform: createTransform(musicAuthorSchema, 'data'),
}

export const music_getMusicHighlighted_Api = {
  name: 'music_getMusicHighlighted_Api',
  backend: `Route::get('musics/get-highlighted-musics', 'MusicController@getHighlightedMusics');`,
  root: API_ROOT_URL,
  path: '/musics/get-highlighted-musics',
  method: 'GET',
  transform: createTransform(musicSchema, 'data'),
}



//  ===================================== course =====================================
export const musicTypeSchema = new schema.Entity(
  'music_types',
  {},
  {
    idAttribute: 'idname',
  }
)


export const music_createMusicType_Api = {
  name: 'music_createMusicType_Api',
  backend: `Route::post('musics/music-types/create', 'MusicTypeController@createMusicType');`,
  root: API_ROOT_URL,
  path: '/musics/music-types/create',
  method: 'POST',
  schema: musicTypeSchema,
  transform: createTransform(musicTypeSchema, 'data'),
}

export const music_deleteMusicType_Api = {
  name: 'music_deleteMusicType_Api',
  backend: `Route::post('musics/music-types/{id}/delete', 'MusicTypeController@deleteMusicType');`,
  root: API_ROOT_URL,
  path: '/musics/music-types/:id/delete',
  method: 'POST',
  schema: musicTypeSchema,
  transform: createTransform(musicTypeSchema, 'data'),
}

export const music_updateMusicType_Api = {
  name: 'music_updateMusicType_Api',
  backend: `Route::post('musics/music-types/{id}/edit', 'MusicTypeController@updateMusicType');`,
  root: API_ROOT_URL,
  path: '/musics/music-types/:id/edit',
  method: 'POST',
  schema: musicTypeSchema,
  transform: createTransform(musicTypeSchema, 'data'),
}

export const music_getMusicTypeById_Api = {
  name: 'music_getMusicTypeById_Api',
  backend: `Route::get('musics/music-types/{id}/get', 'MusicTypeController@getById');`,
  root: API_ROOT_URL,
  path: '/musics/music-types/:id/get',
  method: 'GET',
  schema: musicTypeSchema,
  transform: createTransform(musicTypeSchema, 'data'),
}

export const music_getMusicTypes_Api = {
  name: 'music_getMusicTypes_Api',
  backend: `Route::get('musics/music-types/gets', 'MusicController@getMusicTypes');`,
  root: API_ROOT_URL,
  path: '/musics/music-types/gets',
  method: 'GET',
  paramsFields: ['keyword'],
  schema: musicTypeSchema,
  transform: createListTransform(musicTypeSchema),
}


export const music_getHighlightedMusicTypes_Api = {
  name: 'music_getHighlightedMusicTypes_Api',
  backend: `    Route::get('musics/music-types/fetch-highlighted-items', 'MusicTypeController@getHighlightedMusicTypes');`,
  root: API_ROOT_URL,
  path: '/musics/music-types/fetch-highlighted-items',
  method: 'GET',
  paramsFields: ['keyword'],
  schema: musicTypeSchema,
  transform: createListTransform(musicTypeSchema),
}


export const music_setAsParent_Api = {
  name: 'music_setAsParent_Api',
  backend: `Route::post('musics/music-types/{id}/parent/{parent_id}/set', 'MusicTypeController@setAsParent');`,
  root: API_ROOT_URL,
  path: '/musics/music-types/:id/parent/:parent_id/set',
  method: 'POST',
  schema: musicTypeSchema,
  transform: createTransform(musicTypeSchema, 'data'),
}

export const music_reArrangeMusicTypes_Api = {
  name: 'music_reArrangeMusicTypes_Api',
  backend: `Route::post('musics/music-types/{id}/re-arrange', 'MusicTypeController@reArrangeMusicTypes');`,
  root: API_ROOT_URL,
  path: '/musics/music-types/:id/re-arrange',
  method: 'POST',
  schema: musicTypeSchema,
  transform: createTransform(musicTypeSchema, 'data'),
}

export const music_getRecommendMusicsForWeek_Api = {
  name: 'music_getRecommendMusicsForWeek_Api',
  backend: `Route::get('musics/get-recommend-items/on-week', 'MusicController@getRecommendMusicsForWeek');`,
  root: API_ROOT_URL,
  path: '/musics/get-recommend-items/on-week',
  method: 'GET',
  paramsFields: ['week'],
  schema: musicTypeSchema,
  transform: createListTransform(musicTypeSchema),
}

export const music_getNWeekOnReadingBookFromNow_Api = {
  name: 'music_getNWeekOnReadingBookFromNow_Api',
  backend: `Route::get('musics/get-recommend-items/get-readings', 'MusicController@getNWeekOnReadingBookFromNow');`,
  root: API_ROOT_URL,
  path: '/musics/get-recommend-items/get-readings',
  method: 'GET',
}

export const music_getRecommendMusicsForReadingsBook_Api = {
  name: 'music_getRecommendMusicsForReadingsBook_Api',
  backend: `Route::get('musics/get-recommend-items/get-musics-by-readings-book', 'MusicController@getRecommendMusicsForReadingsBook');`,
  root: API_ROOT_URL,
  path: '/musics/get-recommend-items/get-musics-by-readings-book',
  method: 'GET',
  paramsFields: ['codi_document_row_id'],
}

export const music_getLatestMusics_Api = {
  name: 'music_getLatestMusics_Api',
  backend: `Route::get('musics/get-latest', 'MusicController@getLatestMusics');`,
  root: API_ROOT_URL,
  path: '/musics/get-latest',
  method: 'GET',
  paramsFields: [],
}

export const music_getMostViewedMusics_Api = {
  name: 'music_getMostViewedMusics_Api',
  backend: `Route::get('musics/get-most-viewed', 'MusicController@getMostViewedMusics');`,
  root: API_ROOT_URL,
  path: '/musics/get-most-viewed',
  method: 'GET',
  paramsFields: ['period'],
}

export const music_getRelated_Api = {
  name: 'music_getRelated_Api',
  backend: `Route::get('musics/musics/{id}/get-related', 'MusicController@getRelatedMusics');`,
  root: API_ROOT_URL,
  path: '/musics/musics/:id/get-related',
  method: 'GET',
  schema: musicTypeSchema,
  transform: createListTransform(musicTypeSchema),
  paramsFields: [],
}
